module.exports = __webpack_public_path__ + "img/1.32a4debf.jpg";